import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedList } from '../api/api-response';
import { Cupom, CupomListado } from './cupom.model';

export interface ListarCuponsFiltro {
  search?: string;
  ieTipo?: string;
  ieSituacao?: string;
  skip?: number;
  take?: number;
}

export interface SalvarCupomPayload {
  codCupom: string;
  dsCupom: string;
  dsObservacao?: string | null;
  ieTipo: string;
  ieTipoDesconto: string;
  vlDesconto?: number | null;
  prDesconto?: number | null;
  vlTeto?: number | null;
  dtVigenciaIni: string;
  dtVigenciaFim?: string | null;
  qtUsoMaxGlobal?: number | null;
  qtUsoMaxPessoa?: number | null;
  nrDiasBloqueioReuso?: number | null;
  ieBeneficiario: string;
  iePaiCombo: string;
  ieEmissaoManual: string;
  iePermiteSupForaVigencia: string;
  qtMinProcedimentos?: number | null;
  vlMinSubtotalItens?: number | null;
  vlMinHistorico?: number | null;
  ieSituacao: string;
}

@Injectable({ providedIn: 'root' })
export class CupomService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(filtro?: ListarCuponsFiltro): Observable<ApiResponse<PaginatedList<CupomListado>>> {
    return this.http.get<ApiResponse<PaginatedList<CupomListado>>>(this.url, { params: { ...(filtro ?? {}) } as Record<string, string> });
  }

  obter(nrSequencia: number): Observable<ApiResponse<Cupom>> {
    return this.http.get<ApiResponse<Cupom>>(`${this.url}/${nrSequencia}`);
  }

  criar(payload: SalvarCupomPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(this.url, payload);
  }

  atualizar(nrSequencia: number, payload: SalvarCupomPayload): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.url}/${nrSequencia}`, payload);
  }

  inativar(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/${nrSequencia}`);
  }

  estatisticas(nrSequencia: number): Observable<ApiResponse<CupomEstatisticas>> {
    return this.http.get<ApiResponse<CupomEstatisticas>>(`${this.url}/${nrSequencia}/estatisticas`);
  }

  ultimasAplicacoes(nrSequencia: number, take = 10): Observable<ApiResponse<CupomAplicacaoRecente[]>> {
    return this.http.get<ApiResponse<CupomAplicacaoRecente[]>>(`${this.url}/${nrSequencia}/ultimas-aplicacoes`, { params: { take: take.toString() } });
  }
}

export interface CupomAplicacaoRecente {
  nrSequencia: number;
  dtUso: string;
  nmPaciente: string;
  dsEstabelecimento: string;
  vlDescontoAplicado: number;
  nmOperador: string;
}

export interface CupomUsoPorUnidade {
  cdEstabelecimento: number;
  dsEstabelecimento: string;
  totalUsos: number;
  totalDescontado: number;
}

export interface CupomEstatisticas {
  totalEmitidos: number;
  totalUsados: number;
  totalDisponiveis: number;
  totalExpirados: number;
  totalDescontado: number;
  totalPacientesUnicos: number;
  porUnidade: CupomUsoPorUnidade[];
}
